/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import emptiness from 'shared/ui/mixins/common/emptiness';

// Components
const __vue_script__ = {
    name: 'MetaFieldset',

    mixins: [emptiness],

    props: {
        fieldset: {
            type: Array,
            required: true
        },

        showHiddenFields: {
            type: Boolean,
            default: false,
        },

        settings: {
            type: Object,
            required: true
        },

        context: {
            type: String,
            default: null
        },

        edit: {
            type: Boolean,
            default: false
        },

        value: {
            type: Object,
            required: true
        },

        event: {
            type: Object,
            default: () => ({})
        },

        disabled: {
            type: Boolean,
            default: null // Not an error, this is a special case
        },

        locale: {
            type: String,
            default: null
        },

        isTranslatable: {
            type: Boolean,
            default: false
        },

        translationsKey: {
            type: String,
            default: 'fp_i18n'
        }
    },

    data() {
        return {
            defaultLocale: this.event?.languages?.[0] || 'en',
            innerValue: {}
        };
    },

    computed: {
        isAdminOrSupport() {
            const us = this.$services.user;
            return us.isSuperAdmin() || us.isSupportAgent();
        }
    },

    watch: {
        value: {
            immediate: true,
            deep: true,
            handler(newValue) {
                this.innerValue = newValue;

                this.populateDefaultLocale();
            }
        },

        locale() {
            this.$forceUpdate();
        }
    },

    methods: {
        getValue(control) {
            // If the control is not translatable or no locale is set, return the raw value
            if (!this.isT9n(control)) {
                return this.innerValue[control.field];
            }

            // If the locale is set and translations are available, return the translated value
            if (this.isT9n(control)) {
                if (this.hasOwnT9n(control)) {
                    return this.innerValue[this.translationsKey]?.[this.locale]?.[control.field];
                }

                if (this.locale === this.defaultLocale) {
                    return this.innerValue[control.field];
                } else {
                    return '';
                }
            }

            // If no translation is available, return the raw value
            return this.innerValue[control.field];
        },

        isT9n(control) {
            if (control.kind_options?.not_translatable) {
                return false;
            }
            const kind = control.kind || 'text';
            return this.locale && this.$services.metadata.TRANSLATABLE_KINDS.includes(kind);
        },

        hasOwnT9n(control) {
            return this.hasLocale(control, this.locale);
        },

        hasLocale(control, locale) {
            return (
                this.innerValue[this.translationsKey]?.[locale] &&
                typeof this.innerValue[this.translationsKey]?.[this.locale]?.[control.field] === 'string'
            );
        },

        getFlags(vars) {
            /**
             * @see https://vee-validate.logaretm.com/v2/guide/flags.html#flags
             */
            const {
                untouched, touched, dirty, pristine,
                valid, invalid, validated, changed
            } = vars;
            return {
                untouched, touched, dirty, pristine,
                valid, invalid, validated, changed
            };
        },

        onInput(control, value) {
            if (this.isT9n(control)) {
                if (!this.locale || this.locale === this.defaultLocale) {
                    // Root fields can only be set in the default locale
                    this.$set(this.innerValue, control.field, value);
                }

                this.updateLocales(control, value);
            } else {
                this.$set(this.innerValue, control.field, value);
            }

            this.$emit('input', this.innerValue);
        },

        populateDefaultLocale() {
            if (!this.locale || this.innerValue?.[this.translationsKey]?.[this.locale]) {
                return;
            }

            for (const control of this.fieldset) {
                this.updateLocales(control, this.innerValue[control.field], this.defaultLocale);
            }
        },

        updateLocales(control, value, locale = this.locale) {
            if (!locale || !this.isT9n(control)) {
                return;
            }

            const trKey = this.translationsKey;
            const translations = this.innerValue[trKey] || {};

            if (!translations[locale]) {
                translations[locale] = {};
            }

            translations[locale][control.field] = value || '';
            this.$set(this.innerValue, trKey, translations);
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.hasNoChildren)?_c('fieldset',{ref:"fieldset"},[_vm._l((_vm.fieldset),function(control){return [(Array.isArray(control))?_c('div',{staticClass:"grouped-controls"},[_c('div',{staticClass:"form-groups"},_vm._l((control),function(c){return _c('validation-provider',{key:((c.order) + "-" + (c.field)),attrs:{"rules":_vm.$utils.controls.getControlValidators(c, { model: _vm.innerValue, event: _vm.event, isTranslatable: _vm.isTranslatable, translationsKey: _vm.translationsKey }),"slim":"slim","name":c.field,"mode":"eager"},scopedSlots:_vm._u([{key:"default",fn:function(slotData){return [_c('meta-control',{attrs:{"value":_vm.getValue(c),"settings":_vm.settings,"context":_vm.context,"control":c,"disabled":_vm.disabled,"edit":_vm.edit,"errors":slotData.errors,"event":_vm.event,"locale":_vm.locale,"parent-model":_vm.innerValue,"statuses":_vm.getFlags(slotData),"show-hidden":_vm.showHiddenFields},on:{"behaviour":function (behaviour) { return _vm.$emit('behaviour', behaviour); },"disable":function($event){return _vm.$emit('disable', $event)},"input":function (v) { return _vm.onInput(c, v); },"locale-change":function($event){return _vm.$emit('locale-change', $event)},"multi-input":function (field, value) { return _vm.$emit('multi-input', field, value); },"reload":function($event){return _vm.$emit('reload', $event)},"rev":function (rev) { return _vm.$emit('rev', rev); },"save":function($event){return _vm.$emit('save', $event)}},scopedSlots:_vm._u([(_vm.isT9n(c))?{key:"inside-label",fn:function(ref){return [_c('div',{staticClass:"translatable"},[_c('span',[_vm._v(_vm._s(_vm.$t('generic_form.types.translatable_hint')))])])]}}:null],null,true)})]}}],null,true)})}),1)]):_c('validation-provider',{key:((control.order) + "-" + (control.field)),attrs:{"rules":_vm.$utils.controls.getControlValidators(control, { model: _vm.innerValue, event: _vm.event, isTranslatable: _vm.isTranslatable, translationsKey: _vm.translationsKey }),"slim":"slim","name":control.field,"mode":"eager"},scopedSlots:_vm._u([{key:"default",fn:function(slotData){return [_c('meta-control',{attrs:{"value":_vm.getValue(control),"settings":_vm.settings,"context":_vm.context,"control":control,"disabled":_vm.disabled,"edit":_vm.edit,"errors":slotData.errors,"event":_vm.event,"locale":_vm.locale,"parent-model":_vm.innerValue,"statuses":_vm.getFlags(slotData),"show-hidden":_vm.showHiddenFields},on:{"behaviour":function (behaviour) { return _vm.$emit('behaviour', behaviour); },"disable":function($event){return _vm.$emit('disable', $event)},"input":function (v) { return _vm.onInput(control, v); },"locale-change":function($event){return _vm.$emit('locale-change', $event)},"multi-input":function (field, value) { return _vm.$emit('multi-input', field, value); },"reload":function($event){return _vm.$emit('reload', $event)},"rev":function (rev) { return _vm.$emit('rev', rev); },"save":function($event){return _vm.$emit('save', $event)}},scopedSlots:_vm._u([(_vm.isT9n(control))?{key:"inside-label",fn:function(ref){return [_c('div',{staticClass:"translatable"},[_c('span',[_vm._v(_vm._s(_vm.$t('generic_form.types.translatable_hint')))])])]}}:null],null,true)})]}}],null,true)})]})],2):_vm._e()}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "MetaFieldset.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__